// Guards the auditor shell routes — redirects to activate if no auditor session.
import { Navigate, Outlet } from 'react-router-dom';
import { useAuditorAuthStore } from '@/store/auditor-auth.store';

export function AuditorProtectedRoute() {
  const { isAuditorAuthenticated } = useAuditorAuthStore();

  if (!isAuditorAuthenticated) {
    return <Navigate to="/auditor/activate/" replace />;
  }

  return <Outlet />;
}
